import React from 'react'
import { useSelector } from 'react-redux';
import { selectWorkTicketFilterVisible, selectTileView } from './store/selectors'; // Import the selector
import WorkTicketSearch from './work-ticket-search';
import WorkTicketFilter from './work-ticket-filter';
import WorkTicketTile from './work-ticket-tile';
import WorkTicketTable from './work-ticket-table';

const WorkTicketContent = props => {
    const isFilterVisible = useSelector(selectWorkTicketFilterVisible); // Use the selector
    const showTileView = useSelector(selectTileView); // Use the selector
  return (
    <div className="card table-list-card">
    <div className="card-body">
      <div className="table-top">
        <WorkTicketSearch />
      </div>
      {isFilterVisible && <WorkTicketFilter />}

      {!showTileView ? <WorkTicketTable /> : <WorkTicketTile />}
    </div>
  </div>
);
};

export default WorkTicketContent